import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { useIntl } from 'react-intl';
import moment from 'moment';
import { formatTimestamp } from 'helpers/datetime';
import ActivityIcon from 'svg/activity.svg';
import InjectionIcon from 'svg/injection.svg';
import messages from 'components/Charts/messages';
import styles from './AdditionalCharts.pcss';
const Tooltip = ({ point })=>{
    const intl = useIntl();
    const { data, serieId } = point;
    const { x, y, xEnd, xStart, endTimestamp, yStart } = data;
    const value = yStart || y;
    const type = serieId.replace('-end', '');
    if (!value) return null;
    let title = intl.formatMessage(messages.labels[type]);
    let icon;
    let timeDiff;
    let description;
    switch(type){
        case 'activities':
            icon = /*#__PURE__*/ _jsx(ActivityIcon, {});
            timeDiff = data.relatedData[0].value || 1;
            description = '';
            data.relatedData.forEach((item, index)=>{
                if (index > 0) {
                    description += '\n';
                }
                description += `${item.name}: ${item.value}`;
            });
            break;
        case 'medications':
            title = '';
            data.relatedData.forEach((item, index)=>{
                if (index > 0) {
                    title += ', ';
                }
                if (item.name === 'Long-acting Insulin') {
                    title += `${intl.formatMessage(messages.labels.longTerm)}: ${item.value}`;
                    timeDiff = 24;
                } else if (item.name === 'Fast-acting Insulin') {
                    title += `${intl.formatMessage(messages.labels.fastTerm)}: ${item.value}`;
                    timeDiff = 6;
                }
            });
            icon = /*#__PURE__*/ _jsx(InjectionIcon, {});
            break;
        case 'weight':
        case 'height':
            title += `: ${value}`;
            break;
        default:
            break;
    }
    const shouldShowEndDate = xStart ? timeDiff && x : timeDiff && xEnd;
    const startTime = xStart || x;
    let endTime = endTimestamp || xEnd || x;
    if (data.relatedData && data.relatedData[0]) {
        const momentTime = moment.unix(startTime).utc();
        const addedTime = momentTime.add(data.relatedData[0].value, 'm');
        endTime = moment(addedTime).unix();
    }
    return /*#__PURE__*/ _jsx("div", {
        className: styles.tooltipRelated,
        children: /*#__PURE__*/ _jsxs("div", {
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: styles.tooltipRelated__header,
                    children: [
                        icon,
                        " ",
                        title
                    ]
                }),
                description && /*#__PURE__*/ _jsx("div", {
                    className: styles.tooltip__desciption,
                    children: description
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: styles.tooltipRelated__content,
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: styles.tooltipRelated__timeLine,
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: styles.tooltipRelated__circle
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: styles.tooltipRelated__line
                                }),
                                shouldShowEndDate && /*#__PURE__*/ _jsx("div", {
                                    className: styles.tooltipRelated__circle
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: styles.tooltipRelated__timeRanges,
                            children: [
                                /*#__PURE__*/ _jsx("p", {
                                    children: formatTimestamp(startTime, 'HH:mm DD/MM/YYYY')
                                }),
                                shouldShowEndDate && /*#__PURE__*/ _jsxs(_Fragment, {
                                    children: [
                                        /*#__PURE__*/ _jsx("p", {
                                            className: styles.tooltipRelated__timeRangesHours,
                                            children: `${timeDiff} ${intl.formatMessage(messages.labels.minutes)}`
                                        }),
                                        /*#__PURE__*/ _jsx("p", {
                                            children: formatTimestamp(endTime, 'HH:mm DD/MM/YYYY')
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
export default Tooltip;
